import { Controller } from "@hotwired/stimulus"

// Simple clock that updates every second in HH:MM:SS (24-hour)
export default class extends Controller {
  static targets = ["value", "select"]

  connect() {
    this.offsetMinutes = this.currentOffsetMinutes()
    this.update()
    this.resizeSelect()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
    const now = new Date()
    const utcMs = now.getTime() + now.getTimezoneOffset() * 60000
    const target = new Date(utcMs + this.offsetMinutes * 60000)

    const h = String(target.getHours()).padStart(2, "0")
    const m = String(target.getMinutes()).padStart(2, "0")
    const s = String(target.getSeconds()).padStart(2, "0")

    if (this.hasValueTarget) {
      this.valueTarget.textContent = `${h}:${m}:${s}`
    }
  }

  changeTimezone(event) {
    const raw = event.target.value
    const parsed = parseInt(raw, 10)
    if (!Number.isNaN(parsed)) {
      this.offsetMinutes = parsed
      this.update()
    }
    this.resizeSelect()
  }

  resizeSelect() {
    if (!this.hasSelectTarget) return
    const select = this.selectTarget
    const selectedOption = select.options[select.selectedIndex]
    if (!selectedOption) return

    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    const style = window.getComputedStyle(select)
    ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
    const textWidth = ctx.measureText(selectedOption.text).width
    // padding-left (8px) + padding-right (20px for arrow) + 8px buffer
    select.style.width = `${Math.ceil(textWidth) + 36}px`
  }

  currentOffsetMinutes() {
    if (this.hasSelectTarget) {
      const raw = this.selectTarget.value
      const parsed = parseInt(raw, 10)
      if (!Number.isNaN(parsed)) return parsed
    }
    // Default to browser's local offset from GMT (in minutes)
    return -new Date().getTimezoneOffset()
  }
}

